import type { PageLine } from '@tol/core/types';
export interface BusLine extends PageLine {
  readonly system: string;
  readonly bullet: string;
}
export function isBusLines(v: unknown): v is readonly BusLine[] {
  return (
    Array.isArray(v) &&
    v.every(
      (l: unknown) =>
        typeof l === 'object' &&
        l !== null &&
        'id' in l &&
        typeof l.id === 'string' &&
        'name' in l &&
        typeof l.name === 'string' &&
        'color' in l &&
        typeof l.color === 'string' &&
        'label' in l &&
        typeof l.label === 'string' &&
        'mode' in l &&
        l.mode === 'tube' &&
        'dual' in l &&
        l.dual === false &&
        'system' in l &&
        l.system === 'bus' &&
        'show' in l &&
        typeof l.show === 'string' &&
        'minor' in l &&
        l.minor === true &&
        'bullet' in l &&
        typeof l.bullet === 'string',
    )
  );
}
